import MyAxios from "@/utilize/MyAxios";
import { useQuery } from "@tanstack/react-query";

export default function useGetRetrievePromotionCode(
  promoCode: string | undefined,
  organizationId: string,
) {
  return useQuery({
    queryKey: ["retrievePromotionCode", promoCode, organizationId],
    queryFn: () =>
      MyAxios.get<{ couponId: string; percentOff: number }>(
        `/billing/retrieve-promotion-code/${promoCode}?organizationId=${organizationId}`,
      ).then((res) => res.data),
    enabled: false,
    retry: 1,
  });
}
